import assetPath from '/app/xinglets/profile/main-logged-out/src/xing-id/cover-image/assets/premium_750.webp';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')